import dynamic from 'next/dynamic'
import { useState, useEffect } from 'react'
import MainProductHero from '@/components/Sections/MainProductHero'
import MainProductDetails from '@/components/Sections/MainProductHero/MainProductDetails'
import ProductReviews from '@/components/Sections/ProductReviews'
import CollectionHero from '@/components/Sections/CollectionHero'
import RelatedProducts from '@/components/Sections/RelatedProducts'
import Breadcrumbs from '@/components/Sections/BreadCrumbs/BreadCrumbs'
const ValueProps = dynamic(() => import('@/components/Sections/ValueProps'))
import { getHarvests } from '@/utils/getHarvests'

const ProductContentSections = ({
  sections,
  product,
  variant,
  setSelectedVariant,
  productPurchaseOptions,
  reviewsRef,
  whyBuyFromUs,
  isSubscription,
  footerSettings
}) => {
  const [harvests, setHarvests] = useState([])

  useEffect(() => {
    getHarvests({ product, variant }).then((res) => {
      setHarvests(res)
    })
  }, [variant])

  if (!Array.isArray(sections)) {
    return null
  }
    // Create breadcrumb items based on product data
    const breadcrumbItems = isSubscription
    ? [
        {
          label: 'Choose Your Box',
          href: `/pages/choose-your-plan`
        },
        {
          label: product.title,
          href: `/products/${product.handle}`
        }
      ]
    : [
        {
          label: 'Marketplace',
          href: `/collections/sitka-seafood-market`
        },
        {
          label: product.title,
          href: `/products/${product.handle}`
        }
      ];
  
  // Create detailsItems array with a single string items for product Freezer Box
  let productAccordionHeadersDetailsItems = [];
  let whyBuyFromUsItems = [];

  if (whyBuyFromUs.length > 0) {
    whyBuyFromUsItems = whyBuyFromUs;
  }

  const remainingSections = sections.reduce((filteredSections, section) => {
    if (section._type === 'productAccordionHeaders') {
      const detailsItems = [
        {
          detailsItems: [section.details],
          detailsTitle: section.description,
          points: section.pointsOfInterest,
          subtitle: section.subtitle,
          footer: section.footer
        },
      ]
      productAccordionHeadersDetailsItems = productAccordionHeadersDetailsItems.concat(detailsItems);
    } else {
      filteredSections.push(section);
    }
    return filteredSections;
  }, []);

  return (

<>
    <Breadcrumbs items={breadcrumbItems} />
  {remainingSections.map((section, index) => {
    const type = section?._type

    switch (type) {
      case 'reviewsCarousel':
        return <ProductReviews fields={section} key={section._key} ref={reviewsRef} />
      case 'collectionHero':
        return <CollectionHero fields={section} key={section._key} />
      case 'collectionList':
        if (isSubscription) {
          return null
        }
        return <RelatedProducts fields={section} key={section._key} />
      case 'productHero':
        return (
          <>
            <MainProductHero
              fields={section}
              key={section._key}
              product={product}
              selectedVariant={variant}
              setSelectedVariant={setSelectedVariant}
              whyBuyFromUsItems={whyBuyFromUsItems}
              reviewsRef={reviewsRef}
              isSubscription={isSubscription}
              productPurchaseOptions={productPurchaseOptions}
            />
            {productAccordionHeadersDetailsItems.length > 0 && (
              <MainProductDetails
                productAccordionHeadersDetailsItems={productAccordionHeadersDetailsItems}
                harvests={harvests}
                isSubscription={isSubscription}
                selectedVariant={variant}
              />
            )}
          </>
        )
      case 'valueProps':
        return <ValueProps fields={section} key={section._key} />
      default:
        return null
    }
  })}
</>
)
}

export default ProductContentSections
